export default __webpack_public_path__ + "static/media/End Call.124db822.svg";